import React, { ReactNode } from 'react';
import { extendClassName } from 'utils/common';

interface IBoxWithLightGreyFill {
  additionalClassName?: string;
  children: ReactNode;
  noPadding?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const BoxWithLightGreyFill = ({
  noPadding = false,
  additionalClassName = '',
  children,
  style = {},
}: IBoxWithLightGreyFill) => {
  return (
    <div
      style={style}
      className={extendClassName('boxWithLightGreyFill', additionalClassName)}
    >
      {children}

      <style jsx>
        {`
          .boxWithLightGreyFill {
            background: #f6f6f6;
            border-radius: 10px;
            ${noPadding ? '' : 'padding: 2.25em 1.75em;'}
          }
        `}
      </style>
    </div>
  );
};

export default BoxWithLightGreyFill;
